import { render, staticRenderFns } from "./OpcionesComponent.vue?vue&type=template&id=44aae635"
import script from "./OpcionesComponent.vue?vue&type=script&lang=js"
export * from "./OpcionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports